module.exports = __webpack_public_path__ + "img/31_15.5e531fb9.png";